import { Component, OnInit } from '@angular/core';

import { EnabledAppFacade } from '@app/core/facades/enabled-app.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '184px';

@Component({
  selector: 'app-filter-app',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class AppFilter extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'App';

  constructor(private readonly _data: EnabledAppFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateAppId(value);
    this.valueChange.emit(new FilterChange(FilterType.App, value));
  }

  ngOnInit() {
    this.init(this._data.appId$, this._data.apps$, this._data.apps$);
  }
}
